import {TableCell, TableRow} from "@mui/material";
import {Fragment, useEffect, useState} from "react";
import {dateFormat} from "../../formatters/format";

const Rowlog = ({ props}) => {

    const [data, setData] = useState(props);

    useEffect(() => {
        setData(props);
    },[props])

    return (
        <Fragment>
            <TableRow >
                <TableCell align="left" sx={{width: 100}}>{dateFormat(data?.fecha)}</TableCell>
                <TableCell align="left" sx={{width: 150}}>{data.isSuccess ? "Completado" : "Error"}</TableCell>
                <TableCell align="left"  sx={{width: 50}}>{data.mensaje}</TableCell>
            </TableRow>
        </Fragment>
    )
}

export default Rowlog;
